const toastApi = Symbol('toastApiKey');

export default toastApi;
